import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./features/userSlice";
import seasonReducer from "./features/seasonSlice";

const store = configureStore({
  reducer: {
    user: userReducer,
    season: seasonReducer,
  },
});

export default store;
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
